module.exports = __webpack_public_path__ + "img/join_content_2__slider_4.0badd415.png";